import { render, staticRenderFns } from "./QuestionGroup.vue?vue&type=template&id=aabd5cd0&scoped=true&"
import script from "./QuestionGroup.vue?vue&type=script&lang=ts&"
export * from "./QuestionGroup.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionGroup.vue?vue&type=style&index=0&id=aabd5cd0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aabd5cd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aabd5cd0')) {
      api.createRecord('aabd5cd0', component.options)
    } else {
      api.reload('aabd5cd0', component.options)
    }
    module.hot.accept("./QuestionGroup.vue?vue&type=template&id=aabd5cd0&scoped=true&", function () {
      api.rerender('aabd5cd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/groups/QuestionGroup.vue"
export default component.exports